import { useEffect, useState } from 'react';
import { Outlet,useNavigate } from 'react-router-dom';

import config from '@/config';
import useCache from '@/hooks/useCache';
import useStateHandler from '@/hooks/useStateHandler';
import Loader from '@/shared-components/loader/Loader'; // new loader we must test this one

import Header from './components/Header';
import Info from './components/Info';
import Tabs from './components/Tabs';

import './index.css';

export default function VerifyGallery() {
  const [internalLoading, setInternalLoading] = useState(true);
  const { cacheHandler } = useStateHandler();
  const { loading, fetchData, setFetchData } = useCache(
    "gallery_onboarding_data",
    `${config.apis.api.url}/onboarding/artwork/info`,
    {
      injectToken: true,
      type: "@cache/persist",
      invalidateWhen: ["ARTWORK_DRAFT_SAVED", "NEW_ARTWORK_REQUEST"],
    }
  );

  const navigate = useNavigate();

  const verifyProfileAndContinueToOnboarding = () => {
    cacheHandler.storeInCache("canUserCompleteOnboarding", true, {
      type: "@cache/no-expiration",
    });
    navigate("/onboarding/gallery", { replace: true });
  };

  useEffect(() => {
    if (!loading && fetchData.artworks_count >= 3) {
      verifyProfileAndContinueToOnboarding();
    } else if (!loading) {
      setInternalLoading(false);
    }
  }, [loading]);

  return (
    <>
      {internalLoading ? (
        <div className="verify-gallery__loading-page">
          <Loader className="verify-gallery__spinner" thin />
        </div>
      ) : (
        <div className="verify-gallery__container">
          <Header
            artworksCount={fetchData ? fetchData.artworks.length : 0}
            onBeginClick={verifyProfileAndContinueToOnboarding}
          />
          <div className="verify-gallery__wrap">
            <Info />
            <Tabs artworksCount={fetchData ? fetchData.artworks.length : 0} />
            <div className="verify-gallery__data-wrap">
              <Outlet context={{ fetchData, setFetchData }} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
